// extracted by mini-css-extract-plugin
export default {"input":"EditHomeworkPerformanceForm_input__GQQ3j","del":"EditHomeworkPerformanceForm_del__JKk99"};